import React from 'react';
import {
  Body,
  BodyWithBorder,
  BodyWithGrayBorder,
  CustomAvatar,
  SmallIconButton,
  TitleText,
} from './StoryAvatar.styles';

interface StoryAvatarProps {
  icon: string;
  title: string;
  state: 'my-story' | 'unwatched' | 'watched';
  onClick?: any;
}

const StoryAvatar: React.FC<StoryAvatarProps> = ({
  icon,
  state,
  title,
  onClick,
}) => {
  // const user1 = require("assets/user1.png");
  const plusIcon = require('assets/icons/plus-icon.svg');

  return (
    <>
      {state === 'my-story' ? (
        <Body onClick={onClick}>
          <CustomAvatar src={icon} />
          <TitleText>{title}</TitleText>
          <SmallIconButton>
            <img src={plusIcon.default} alt="plus icon" />
          </SmallIconButton>
        </Body>
      ) : state === 'watched' ? (
        <BodyWithGrayBorder onClick={onClick}>
          <CustomAvatar src={icon} />
          <TitleText style={{ color: '#fff' }}>{title}</TitleText>
        </BodyWithGrayBorder>
      ) : state === 'unwatched' ? (
        <BodyWithBorder onClick={onClick}>
          <CustomAvatar src={icon} />
          <TitleText style={{ color: '#fff' }}>{title}</TitleText>
        </BodyWithBorder>
      ) : (
        <></>
      )}
    </>
  );
};

export default StoryAvatar;
